export var IdMarketImprovement;
(function (IdMarketImprovement) {
    IdMarketImprovement[IdMarketImprovement["ContractSlotBonus"] = 1] = "ContractSlotBonus";
})(IdMarketImprovement || (IdMarketImprovement = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/market/IdMarketImprovement.ts
// module id = 1997
// module chunks = 3